import React, { Component } from 'react';
import { Link as LinkFeather } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { AddButton } from '../../components/AddButton';
import { Loader } from '../../components/Loader';
import * as actions from "../../redux/cronexpressions";

class CronExpressions extends Component {
    componentDidMount() {
        this.props.fetchcronexpressions(this.props);
    }

    renderTable() {
        return !this.props.cronexpressions ? null : <div>
            <AddButton to={`/cronexpressions/new`} />
            <table className='table table-striped'>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Expression</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.props.cronexpressions.map(forecast =>
                        <tr key={forecast.id}>
                            <td>{forecast.description}</td>
                            <td>{forecast.expression}</td>
                            <td><Link to={`/cronexpressions/${forecast.id}`}><LinkFeather>Edit</LinkFeather></Link></td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    }

    render() {
        return (
            <div>
                <h1>Cron Expressions</h1>
                <Loader loading={this.props.loading}>
                    {this.renderTable()}
                </Loader>
            </div>
        );
    }
}

const mapStateToProps = ({ cronexpressions }) => ({
    cronexpressions: cronexpressions.cronexpressions,
    loading: cronexpressions.loading,
    error: cronexpressions.error
});

export default connect(mapStateToProps, actions)(withRouter(CronExpressions));


// WEBPACK FOOTER //
// ./src/pages/CronExpressions/CronExpressions.js